(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller(
      "myPendingConnectionsController",
      myPendingConnectionsController,
    );

  myPendingConnectionsController.$inject = [
    "connectionsPayload",
    "ConnectRequestsApi",
    "alerts",
    "thisUser",
    "$scope",
  ];

  function myPendingConnectionsController(
    connectionsPayload,
    ConnectRequestsApi,
    alerts,
    thisUser,
    $scope,
  ) {
    var vm = this;
    vm.limit = 8;

    // properties
    vm.pendingRequests = angular.copy(connectionsPayload);
    vm.pendingRequests.data = [];
    vm.filters = {
      with: "userTo",
      page: 1,
      page_size: 999,
    };

    // methods
    vm.updateFilters = updateFilters;

    // create a new connect resource for each one
    angular.forEach(connectionsPayload.data, function (connection) {
      vm.pendingRequests.data.push(
        new ConnectRequestsApi(connection).transform(),
      );
    });

    /**
     * Requests new connections from the server with the provided filters
     * @return {void}
     */
    function updateFilters() {
      vm.isLoading = true;
      ConnectRequestsApi.get(
        vm.filters,
        function (result) {
          vm.pendingRequests = result;
          vm.isLoading = false;
        },
        function () {
          vm.isLoading = false;
          alerts.emit({
            theme: "error",
            title: "Could not load more connections.",
            messages: ["Please try again later."],
          });
        },
      );
    }
    $scope.loadMore = function () {
      var increamented = vm.limit + 4;
      vm.limit =
        increamented > vm.pendingRequests.length
          ? vm.pendingRequests.length
          : increamented;
    };
  }
})(angular);
